import {sabahRaporuMesajiOlustur} from "@/plugins/uyap-plugin/senkronSabahRaporuMesaji";
import {isletimSistemiBildirimi, uyariSesi} from "@/plugins/kritikUyari";
import app from "@/main";
import {gunDamgasi} from "@/components/eicrapro/senkron/senkronRaporOzeti";
import {SENKRON_KAPI_ATESLEME_ARALIGI_MS, senkronAcikMiTazeleyerek} from "@/utils/senkronKapisi";

/**
 * Sabah raporu bildirimi — uygulama tarafı (Faz 3, DEV-2968).
 *
 * F3-D5: ÇEKME modelidir. Sunucudan push altyapısı yok ve gerekmiyor; uygulama
 * açıksa ayarlanan saatte bir kez rapor ucu çekilir.
 *
 * Çekilen rapor store'a da yazılır (`raporYukle`), böylece kullanıcı bildirime
 * tıklayıp İşlemler sayfasına geldiğinde şerit ikinci bir istek atmadan aynı
 * sayıları gösterir.
 *
 * OTOMATİK SORGU KAPISI (DEV-2603, karar 20.10.2026): kapı kapalıyken sunucuya hiç
 * istek atılmaz ve bildirim verilmez. Kapı ateşleme ANINDA okunur (kurulumda değil):
 * kullanıcı bilgisi kurulumdan sonra yüklenmiş ya da kapı kapanmış olabilir.
 * Önbellekteki değer açıksa sunucudan (sessiz, 10 dk'dan taze değilse) teyit edilir.
 */
export async function senkronSabahRaporunuCalistir(store?: any): Promise<void> {
    // Store ÇAĞIRANDAN gelir; `app.$store` yalnız yedektir. `@/main`den okunan
    // app singleton'ı uygulama açılışında dairesel import yüzünden `undefined`
    // olabiliyor ve `app.$store` okuması TypeError atıp bildirimi sessizce
    // düşürüyordu (zamanlayıcı günü çoktan damgaladığı için ikinci şans da yoktu).
    const kaynak = store ?? (app ? app.$store : null);

    // Store bilinmiyorsa kapı da bilinmiyor demektir: KAPALI.
    if (!(await senkronAcikMiTazeleyerek(kaynak, SENKRON_KAPI_ATESLEME_ARALIGI_MS))) return;

    try {
        const gun = gunDamgasi();

        // Store üzerinden çekilir: İşlemler şeridi aynı veriyi ikinci istek atmadan
        // kullanır.
        const rapor = await kaynak.dispatch("senkronPlan/raporYukle", {gun, zorla: true});

        const mesaj = sabahRaporuMesajiOlustur(rapor as any);
        if (!mesaj) return;

        isletimSistemiBildirimi(mesaj.baslik, mesaj.metin);
        if (mesaj.kritikMi) uyariSesi();
    } catch (e) {
        console.error("Senkron sabah raporu alınamadı:", e);
    }
}
